import React from 'react';
import ReactDOM from 'react-dom';

import Configuration from './Configuration';
import App from './App';

/**
 * Update the widget configuration object with parameters found from
 * widget script tag attributes.
 */
const updateConfiguration = () => {
    // Retrieve widget configuration from the script element with "cccu-script" id.
    const script = document.getElementById("cccu-script");

    if (!script) {
        console.error("Unable to start the CCCU widget : No <script> with id 'cccu-script' was found.");
        return;
    }

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    // Extract configuration from script tag data
    Configuration.derivedmodel = (isIE === true)? "":script.getAttribute('data-derivedmodel');
    Configuration.country = script.getAttribute('data-country');
    Configuration.language = script.getAttribute('data-language');
    Configuration.brand = script.getAttribute('data-brand');
    Configuration.vehicleUse = script.getAttribute('data-vehicle-use');
    Configuration.disableCache = script.getAttribute('data-disable-cache');
    Configuration.triggerElementRef = document.querySelector(script.getAttribute('data-element-selector'));

    // Checking widget configuration
    try {
        Configuration.validate();
    } catch (err) {
        return console.error(`CCCU-WIDGET error : ${err.message}`);
    }
}

/**
 * Mount the widget app in DOM.
 */
const mountWidget = () => {
    // Creating the widget container and start the app
    const appContainer = document.createElement('div');
    appContainer.setAttribute('id', "cccu-widget");
    document.body.appendChild(appContainer);
    
    ReactDOM.render(<App />, appContainer);
}

// Create the element on which the app will start
window.addEventListener("load", () => {
    updateConfiguration();

    // If the S3 endpoint is provided in process.env.REACT_APP_S3_CSS_URL,
    // Add the CSS link pointing to it at the beginning of <head> node
    if (process.env.REACT_APP_S3_URL) {
        // Build the widget CSS link
        const widgetLink  = document.createElement('link');
        widgetLink.id   = 'cccu-style';
        widgetLink.rel  = 'stylesheet';
        widgetLink.type = 'text/css';
        widgetLink.href = `${process.env.REACT_APP_S3_URL}/cccu-widget.css`;
        widgetLink.media = 'all';

        // Retrieves the first link tag. If it exists, insert the
        // widget CSS link before it, else insert it at the end of
        // the head node.
        const firstLinkTag = document.getElementsByTagName('link')[0];

        document.getElementsByTagName('head')[0].insertBefore(widgetLink, firstLinkTag || null);
    }

    // Creating the widget container and start the app
    mountWidget();
});

/**
 * Triggered from demo only. Used to update the widget configuration on the fly.
 */
document.addEventListener('cccu-update-config', () => {
    const appNode = document.getElementById('cccu-widget');
    ReactDOM.unmountComponentAtNode(appNode);
    document.body.removeChild(appNode);

    updateConfiguration();
    mountWidget();
});



// WEBPACK FOOTER //
// ./src/index.js